import { Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { InstancesService } from 'src/app/services/api/instances.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';

@Component({
  selector: 'app-environment-component-update',
  templateUrl: './environment-component-update.component.html',
  styleUrl: './environment-component-update.component.scss',
  standalone: false
})
export class EnvironmentCompenentUpdateComponent {
  private destroyRef = inject(DestroyRef);

  constructor(
    private instanceService: InstancesService,
    private toastrService: CustomToastrService,
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
  ) { }

  instanceId: string;
  showSpinner: boolean;
  dataLoaded: boolean;
  data: any;
  ngOnInit() {
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.getInstanceDetails();
  }

  getInstanceDetails(): void {
    this.showSpinner = true;
    this.dataLoaded = false;
    this.instanceService.getInstanceDetails(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.showSpinner = false;
          this.dataLoaded = true;
          this.data = data;
        }
      },
        (error) => {
          setTimeout(() => {
            this.showSpinner = false;
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
  }

}
